module.exports = __webpack_public_path__ + "static/media/freeTrial.51366cf5.svg";